import styled from "styled-components";

export const Wrapper = styled.div`
  position: relative;
  margin: 0 0 20px;
  max-width: 450px;
  cursor: pointer;
  display: block !important;
  justify-content: unset !important;
  align-items: unset !important;

  > div {
    position: relative;
  }

  select {
    overflow: hidden;
    width: 100%;
    display: block;
    position: relative;
    transition: all 0.2s;
    outline: none;
    font-size: 14px;
    padding-left: 14px;
    padding-right: 32px;
    height: 36px;
    line-height: 36px;
    border-radius: 4px;
    border: 1px solid var(--border-shadow);
    background-color: var(--white);
    text-overflow: ellipsis;
    cursor: pointer;
  }

  option {
    overflow: hidden;
    max-width: 430px;
    text-overflow: ellipsis;
  }

  svg {
    position: absolute;
    top: 50%;
    right: 8px;
    margin-top: -12px;
    pointer-events: none;
  }

  &:disabled {
    pointer-events: none;
    opacity: 0.5;
  }
`;

export const Label = styled.label`
  display: block !important;
  margin: 0 0 6px;
  font-size: 14px;
  font-weight: 600;
  align-self: unset !important;
  color: var(--gray);
`;

export const Error = styled.p`
  display: block;
  font-weight: 600;
  color: red;
`;
